(function () {
  'use strict';
  const campaign = 'christmas_panoramas_2026';
  const storageKey = 'cp_christmas_referral_2026';
  const campaignEnd = Date.parse('2026-12-26T05:00:00Z');
  const now = Date.now();
  const incoming = new URL(location.href).searchParams.get('cp_ref');
  if (incoming === 'clear') {
    try { localStorage.removeItem(storageKey); } catch (_) {}
    fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes:{cp_referrer_id:null,cp_referral_campaign:null}})
    }).then(r => r.json()).then(cart => {
      const status = document.getElementById('cp-referral-status');
      if (status && !cart.attributes?.cp_referrer_id) {status.hidden = false; status.textContent = 'Referral removed from this visit.';}
    }).catch(() => {});
    return;
  }
  let referral = null;
  try { referral = JSON.parse(localStorage.getItem(storageKey)); } catch (_) {}
  if (!referral || !/^[1-9][0-9]{4,19}$/.test(referral.id || '') || referral.expires <= now) referral = null;
  if (now < campaignEnd && /^[1-9][0-9]{4,19}$/.test(incoming || '')) {
    referral = {id: incoming, campaign, expires: campaignEnd};
    try { localStorage.setItem(storageKey, JSON.stringify(referral)); } catch (_) {}
  }
  if (!referral || now >= campaignEnd) return;
  const attributes = {cp_referrer_id: referral.id, cp_referral_campaign: campaign};
  let syncing;
  async function sync() {
    if (syncing) return syncing;
    syncing = fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes})
    }).then(r => {if (!r.ok) throw Error('We could not save the referral. Please try again.'); return r.json();}).then(cart => {
      const linked = cart.attributes && cart.attributes.cp_referrer_id === referral.id && cart.attributes.cp_referral_campaign === campaign;
      if (!linked) throw Error('Referral was not saved');
      const status = document.getElementById('cp-referral-status');
      if (status) {status.hidden = false; status.textContent = 'Your friend’s referral is linked. Shop in this browser to keep it connected.';}
      return cart;
    })
      .finally(() => {syncing = null;});
    return syncing;
  }
  function markForms() {
    document.querySelectorAll('form[action*="/cart"]').forEach(form => {
      if (form.action.includes('/cart/add')) return;
      for (const [key, value] of Object.entries(attributes)) {
        const name = 'attributes[' + key + ']';
        let input = form.querySelector('input[name="' + name + '"]');
        if (!input) {input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input);}
        input.value = value;
      }
    });
  }
  window.SunshineReferral = {attributes, sync};
  sync().catch(() => {});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markForms, {once:true});
  else markForms();
  document.addEventListener('shopify:section:load', markForms);
  document.addEventListener('submit', markForms, true);
  // Ensure cart attributes finish saving before a normal checkout navigation.
  let checkoutReady = false;
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
    if (!trigger || checkoutReady) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {await sync(); checkoutReady = true; trigger.click(); checkoutReady = false;}
    catch (_) {alert('We could not save your referral. Please try checkout again.');}
  }, true);
})();
